import { render, staticRenderFns } from "./SGoodsCatePointe.vue?vue&type=template&id=780a2af6&scoped=true"
import script from "./SGoodsCatePointe.vue?vue&type=script&lang=js"
export * from "./SGoodsCatePointe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a2af6",
  null
  
)

export default component.exports